export default {
  SET_TOGGLE_SHARE: 'SET_TOGGLE_SHARE'
}